import { Text } from "@chakra-ui/react"
import React from "react"
import { useTranslation } from "react-i18next"
import { SDKContext } from "src/context/SDKContext"
import { PlansPageStyling } from "src/context/types"
import { useBrowserType } from "src/hooks/useBrowserType"
import usePageStyling from "src/hooks/usePageStyling"
import useWindowSize from "src/hooks/useWindowSize"
import axios from "src/shared/axios"
import { PlansButton } from "./PlansButton"
import { PlansData } from "./PlansData"

export const MobileSubscription: React.FC<{
  plansData: PlansData
}> = ({ plansData }) => {
  const { t } = useTranslation()
  const { screenSize } = useWindowSize()
  const { isSafariMobile, isAndroid } = useBrowserType()
  const isMobile = isSafariMobile || isAndroid
  const isLandscape = screenSize.width > screenSize.height
  const meetingClient = React.useContext(SDKContext)
  const plansPageStyles: PlansPageStyling = usePageStyling("plansPageStyling")

  const activeSubscription = plansData.unsubscribeDetectedAt == null

  // The case where the user has an active subscription
  if (activeSubscription) {
    return (
      <>
        <Text
          color={plansPageStyles?.planPagePanelSubTextColor}
          textAlign={"center"}
        >
          You have an active mobile subscription.
          <br />
          You can adjust it through your device settings or app store.
        </Text>
        <div style={{ padding: "1px" }} />

        <PlansButton
          onClick={async () => {
            if (isMobile) {
              meetingClient?.nativeBridge.eventShowMobileSubscriptionSettings()
            }
          }}
          disabled={!isMobile}
          isMobile={isMobile}
          isLandscape={isLandscape}
          buttonText={t("Manage subscription on your device")}
        />

        <PlansButton
          onClick={async () => {
            if (isMobile) {
              meetingClient?.nativeBridge.eventShowMobilePaywall()
            } else {
              const res = await axios.post(
                meetingClient?.envConfig.CREATE_STRIPE_CHECKOUT,
                {
                  host: meetingClient?.envConfig.DOMAIN_HOSTNAME
                },
                {
                  withCredentials: true
                }
              )
              window.location.href = res.data.redirect
            }
          }}
          isMobile={isMobile}
          isLandscape={isLandscape}
          buttonText={t("Change Plan")}
        />
      </>
    )
  }

  // The case where the user's subscription is cancelled or has not renewed for whatever reason
  return (
    <>
      <Text
        color={plansPageStyles?.planPagePanelSubTextColor}
        textAlign={"center"}
      >
        Your subscription has ran out without renewing.
        <br />
        Press the button below to restart it.
      </Text>

      <PlansButton
        onClick={async () => {
          if (isMobile) {
            meetingClient?.nativeBridge.eventShowMobilePaywall()
          } else {
            const res = await axios.post(
              meetingClient?.envConfig.CREATE_STRIPE_CHECKOUT,
              {
                host: meetingClient?.envConfig.DOMAIN_HOSTNAME
              },
              {
                withCredentials: true
              }
            )
            window.location.href = res.data.redirect
          }
        }}
        isMobile={isMobile}
        isLandscape={isLandscape}
        buttonText={t("Extend Access")}
      />
    </>
  )
}
